import React from "react";
import BreadcrumbArea from "../components/BreadcrumbArea/BreadcrumbArea";
import InnerContactArea from "../components/Contact/InnerContactArea";
import Layout from "../layouts/Layout";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Get in touch with Innovatix Hub for expert design in Hobart, TAS. Reach out today and let us help bring your creative ideas to life!"
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta
          property="og:title"
          content="Contact Us – Innovatix Hub Australia"
        />
        <meta
          property="og:description"
          content="Get in touch with Innovatix Hub for expert design in Hobart, TAS. Reach out today and let us help bring your creative ideas to life!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta property="og:url" content="https://innovatixhub.com.au/contact" />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.webp"
        />

        <link rel="canonical" href="https://innovatixhub.com.au/contact" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Contact Us"}
          subtitle={"Contact"}
          className={"breadcrumb-area-four pt-175 pb-160"}
          showShape={false}
          showShapeThree={true}
        />
        <InnerContactArea />
      </Layout>
    </>
  );
};

export default ContactPage;
